var map = {
	"./Rectangle 79.png": "57e4",
	"./clients/Adidas.png": "7f09",
	"./clients/Adspin.png": "08eb",
	"./clients/Avida.png": "a00d",
	"./clients/Ayala-Malls.png": "8442",
	"./clients/BBPB.png": "3c57",
	"./clients/Bayanihan-Para-Sa-Magsasaka.png": "fdae",
	"./clients/Called-To-Rescue.png": "9fa3",
	"./clients/Digital-Spin.png": "85f7",
	"./clients/Eco-Explorations.png": "5a9b",
	"./clients/For-the-Future.png": "8458",
	"./clients/GSM.png": "caf6",
	"./clients/Green-Sun.png": "d5b3",
	"./clients/Kids-Who-Farm.png": "177b",
	"./clients/Lokal-Lab.png": "4a9d",
	"./clients/MUNI-PH.png": "632f",
	"./clients/Museo-Pambata.png": "0d3c",
	"./clients/PLDT-Smart.png": "aa86",
	"./clients/Philippine-Parks.png": "dee7",
	"./clients/SDSN Youth Logo (1).png": "e42a",
	"./clients/SDSN.png": "f690",
	"./clients/Stages-Sessions.png": "41a4",
	"./clients/Tamaraw-Society.png": "94c3",
	"./clients/Taya-Pinas.png": "6e9c",
	"./clients/Tukod.png": "7cfd",
	"./clients/UNICEF-Philippines.png": "b22d",
	"./clients/WWF.png": "74f9",
	"./clients/Where-To-Next.png": "1ef3",
	"./clients/Youthtopia.png": "5c70",
	"./confirm-check.png": "85d0",
	"./contact_us_asset.png": "cc34",
	"./exit_icon.png": "d423",
	"./footer-fb.png": "5434",
	"./footer-ig.png": "135a",
	"./footer-m.png": "28e4",
	"./footer-rectangle.png": "0b8c",
	"./headerlogo.png": "6770",
	"./homeheader.jpg": "1c27",
	"./homeillustration.png": "1be9",
	"./service_a.png": "12f2",
	"./service_b.png": "df4e",
	"./service_c.png": "6908",
	"./service_header.png": "1f15",
	"./services_value.png": "83c3",
	"./tayo-logo-black.png": "c398",
	"./tayo-logo.png": "7b5c",
	"./tayo-video-thumbnail.png": "f191",
	"./template-projects/aura/artesania_cover.jpg": "3ad7",
	"./template-projects/bakes/bakes_cover.png": "7499",
	"./template-projects/cmw/cmw_cover.png": "c2c0",
	"./template-projects/gsm/gsm_cover.png": "fb00",
	"./template-projects/guiuan/guiuan_cover.png": "ef68",
	"./template-projects/h2018/habilin2018_cover.png": "f06a",
	"./template-projects/immersion/immersions_cover.jpg": "18b3",
	"./template-projects/k2016/kam2016_cover.png": "10a9",
	"./template-projects/k2017/kam2017_cover.png": "d5ef",
	"./template-projects/k2018/kam2018_cover.png": "8fbb",
	"./template-projects/k2019/kam2019_cover.png": "1e25",
	"./template-projects/k2019xretaso/retasoxkam_cover.jpg": "6804",
	"./template-projects/kakampi/kakampi_cover.png": "942e",
	"./template-projects/kxwwf/wwfxkam_cover.jpg": "1299",
	"./template-projects/launch/adidas_cover.jpg": "7f01",
	"./template-projects/laya/laya_cover.jpg": "159e",
	"./template-projects/museo/museo_cover.png": "3dd1",
	"./template-projects/outwork/ow_cover.jpg": "470f",
	"./template-projects/pplplanet/FP&P_COVER.png": "3111",
	"./template-projects/pref/pref_cover.png": "059a",
	"./template-projects/smart/smart_1.png": "4a3c",
	"./template-projects/smart/smart_2.png": "2670",
	"./template-projects/smart/smart_carousel_1.png": "5232",
	"./template-projects/smart/smart_carousel_2.png": "9467",
	"./template-projects/smart/smart_carousel_3.png": "b64c",
	"./template-projects/smart/smart_carousel_4.jpg": "199a",
	"./template-projects/smart/smart_carousel_5.jpg": "98c7",
	"./template-projects/smart/smart_cover.png": "e956",
	"./template-projects/syl/SYL_cover.png": "9463",
	"./template-projects/takbo/takbo_cover.png": "df50",
	"./template-projects/typhoon/typhoon_cover.png": "233f",
	"./template-projects/uscm/habfbgrp_cover.png": "c4fd",
	"./whoweare/WHOWEARE_1.png": "b65d",
	"./whoweare/WHOWEARE_2.png": "2dbd",
	"./whoweare/WHOWEARE_3.png": "abac",
	"./whoweare/WHOWEARE_4.png": "aa82",
	"./whoweare/WHOWEARE_5.png": "ce24",
	"./whoweare/WHOWEARE_6.png": "43dd",
	"./whoweare/WHOWEARE_7.png": "b684",
	"./whoweare/hut1.png": "424c",
	"./whoweare/hut2.png": "ffcb",
	"./whoweare/walking.png": "9186",
	"./wwa-projects/habilin/HABILIN_LOGO.png": "0e58",
	"./wwa-projects/habilin/HABILIN_ROUND.png": "8624",
	"./wwa-projects/habilin/HAB_1.png": "3b5e",
	"./wwa-projects/habilin/HAB_2.png": "070d",
	"./wwa-projects/habilin/HAB_COVER.png": "7ea9",
	"./wwa-projects/inyo/INYO_COVER.png": "c865",
	"./wwa-projects/inyo/INYO_ROUND.png": "474f",
	"./wwa-projects/kamalayan/KAMALAYAN_LOGO.png": "1403",
	"./wwa-projects/kamalayan/KAMALAYAN_ROUND.png": "1066",
	"./wwa-projects/kamalayan/KAM_1.png": "9cc6",
	"./wwa-projects/kamalayan/KAM_2.png": "16fd",
	"./wwa-projects/kamalayan/KAM_COVER.png": "6f3a",
	"./wwa-projects/kfk/KFK_COVER.png": "e3e0",
	"./wwa-projects/kfk/KFK_LOGO.png": "8fe0",
	"./wwa-projects/kfk/KFK_MOBILE.png": "2dcd",
	"./wwa-projects/kfk/KFK_ROUND.png": "5640",
	"./wwa-projects/kfk/KFK_VOL.png": "a8ce",
	"./wwa-projects/kfk/KFK_WHAT.png": "1d67",
	"./wwa-projects/kfk/KFK_WHY.png": "54f3",
	"./wwa-projects/kfk/head-1.png": "41c7",
	"./wwa-projects/kubo/KUBO_COVER.png": "6e45",
	"./wwa-projects/kubo/KUBO_ROUND.png": "d450",
	"./wwa-projects/retaso/RETASO_COVER.png": "ac5c",
	"./wwa-projects/retaso/RETASO_LOGO.png": "dcb5",
	"./wwa-projects/retaso/RETASO_ROUND.png": "2ab6",
	"./wwa-projects/retaso/RET_1.png": "6d04",
	"./wwa-projects/retaso/RET_2.png": "9e47"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e1";